import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import { getRouteSeoByPath } from "./routeMeta";

const RouteSeo = () => {
  const location = useLocation();
  const routeSeo = getRouteSeoByPath(location.pathname);

  return (
    <Seo
      title={routeSeo.title}
      description={routeSeo.description}
      keywords={routeSeo.keywords}
      canonicalPath={location.pathname}
      noIndex={routeSeo.noIndex}
      noFollow={routeSeo.noFollow}
    />
  );
};

export default RouteSeo;
